import { redeemOfferCode } from './AvantBasic/DirectMailService'
import { ODSApiCallHelper, OdsSSNApiCallHelper } from './ODSApiCall'
import { condenseParams, paramsToURL } from '../context/ApplyParamsContext'
import { MAX_SSN_RETRIES } from '../helpers/constants'
import { getEnvVar } from '../helpers/environment'
import { getExistingAttributionParams } from '../helpers'

const odsAPIResponse = {
  requestResponse: null,
  cardOffer: null,
  modal: true,
  offerType: null,
  offerId: null,
  prefillLink: null,
  isMailOffer: false,
  returningCustomerFlag: false,
  customerName: null
}

const ssnModalResponse = {
  requestResponse: null,
  cardOffer: null,
  modal: false,
  offerType: null,
  offerId: null,
  prefillLink: null,
  isMailOffer: true,
  returningCustomerFlag: false,
  customerName: null,
  ssnSuccess: null,
  ssnRetryCount: 0,
  offerExpired: null
}

// Direct Mail api call

const digitalPrescreenUrl = getEnvVar('DIGITAL_PRESCREEN_URL')

// ODS api call
export async function ODSFormApiCall(values, odsData) {
  const { applyParams } = odsData
  const { first_name } = values
  odsAPIResponse.customerName = first_name

  try {
    const { response } = await ODSApiCallHelper(values, odsData)
    const { requestId, offerType } = response
    odsAPIResponse.offerType = offerType

    const odsApiRequestResponseTemplate = {
      status: null,
      offerType,
      requestId
    }

    if (odsAPIResponse.offerType === 'none' || odsAPIResponse.offerType === 'suppression') {
      odsAPIResponse.modal = false
      odsAPIResponse.requestResponse = {
        ...odsApiRequestResponseTemplate,
        status: 'Unsuccessful Offer'
      }
    } else if (odsAPIResponse.offerType === 'digital') {
      const { returningCustomerFlag, cardOffer } = response
      odsAPIResponse.cardOffer = cardOffer
      odsAPIResponse.returningCustomerFlag = returningCustomerFlag

      // for adding parameters to url
      let urlParams = paramsToURL(condenseParams(applyParams).extraApplyParams)
      let dynamicApplyParamsURL = paramsToURL(getExistingAttributionParams())
      dynamicApplyParamsURL = dynamicApplyParamsURL.replace('&', '')

      urlParams = urlParams === '' ? dynamicApplyParamsURL : `${urlParams}&${dynamicApplyParamsURL}`

      const prefillRoute = () =>
        window.location.replace(`${digitalPrescreenUrl}/prefill/${requestId}?${urlParams}`)

      odsAPIResponse.prefillLink = () => prefillRoute()
      // for digital, no ssn modal, it goes to offer directly
      odsAPIResponse.modal = false
      odsAPIResponse.requestResponse = {
        ...odsApiRequestResponseTemplate,
        status: 'Successful Offer'
      }
    } else {
      // is a direct mail offer and would need to go to ssn modal
      odsAPIResponse.success = true
      odsAPIResponse.offerId = requestId
      odsAPIResponse.requestResponse = {
        ...odsApiRequestResponseTemplate,
        status: 'SSN Verification not completed'
      }
    }
    return odsAPIResponse
  } catch (err) {
    console.log(err)
  }
}

export async function OdsSsnApiCall(values, odsData) {
  try {
    const { offerId, customerName, requestResponse } = odsAPIResponse
    const { requestId } = requestResponse
    const { ssnApiResponse } = await OdsSSNApiCallHelper(values, offerId, odsData)
    const ssnApiRequestResponseTemplate = {
      status: null,
      offerType: 'directMail',
      requestId: offerId
    }
    if (ssnApiResponse === null) {
      if (ssnModalResponse.ssnRetryCount === MAX_SSN_RETRIES) {
        ssnModalResponse.ssnSuccess = false
        ssnModalResponse.requestResponse = {
          ...ssnApiRequestResponseTemplate,
          status: 'Unsuccessful Offer'
        }
        const maxRetriesSSNModalResponse = { ...ssnModalResponse }
        return maxRetriesSSNModalResponse
      }
      ssnModalResponse.requestResponse = {
        ...ssnApiRequestResponseTemplate,
        status: 'Failed SSN attempt'
      }
      ssnModalResponse.ssnRetryCount += 1
      return ssnModalResponse
    }
    if (ssnApiResponse === 'fatalError') {
      ssnModalResponse.ssnSuccess = false
      ssnModalResponse.requestResponse = {
        ...ssnApiRequestResponseTemplate,
        status: 'Unsuccessful Offer'
      }
      const fatalErrorModalResponse = { ...ssnModalResponse }
      return fatalErrorModalResponse
    }
    ssnModalResponse.ssnSuccess = true

    const directMailResponse = await redeemOfferCode({
      code: ssnApiResponse.cardOffer.promoCode,
      ssn: values.last_4_of_ssn,
      productType: 'credit_card',
      requestId
    }).catch(() => {
      ssnModalResponse.offerExpired = true
    })

    if (directMailResponse) {
      const { returningCustomerFlag, cardOffer } = ssnApiResponse
      const prefillRoute = () => window.location.replace(directMailResponse.applicationURL)

      ssnModalResponse.prefillLink = () => prefillRoute()
      ssnModalResponse.offerExpired = false
      ssnModalResponse.customerName = customerName
      ssnModalResponse.cardOffer = cardOffer
      ssnModalResponse.returningCustomerFlag = returningCustomerFlag
      ssnModalResponse.modal = false
      ssnModalResponse.requestResponse = {
        ...ssnApiRequestResponseTemplate,
        status: 'Successful Offer'
      }
    } else {
      ssnModalResponse.offerExpired = true
      ssnModalResponse.requestResponse = {
        ...ssnApiRequestResponseTemplate,
        status: 'Unsuccessful Offer'
      }
    }
    const ssnModalSuccessfulResponse = { ...ssnModalResponse }
    return ssnModalSuccessfulResponse
  } catch (err) {
    console.log(err)
  }
}
